// removed by extract-text-webpack-plugin
module.exports = {"tagplayContainer":"_3pcLp0lIAqC3VKdKvyi6L","columns":"_1zNX4YqKNVL2Evku8XukuJ","column":"_3nY5v2tVc0PVT9vyR7jyQd"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-868268c4","scoped":false,"hasInlineConfig":false}!./~/stylus-loader?{"sourceMap":true}!./src/styles/TagplayWidget.styl
// module id = 12
// module chunks = 0